import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'found';

import {
  updateStorage
} from '../../utils/storage';

const PAGES = [
  ['/wizard/reference', 'Reference'],
  ['/wizard/isolate', 'Isolate data'],
  ['/wizard/rx-list', 'Rx history data'],
];

import style from './style.css';


export default class Navigator extends React.Component {

  static propTypes = {
    rawDataCollection: PropTypes.object,
    onNavClick: PropTypes.func,
  };

  static contextTypes = {
    router: PropTypes.shape({
      replace: PropTypes.func.isRequired,
      push: PropTypes.func.isRequired
    }).isRequired
  };

  isActiveTag(url, pagename) {
    const {rawDataCollection} = this.props;

    if (url === window.location.pathname) {
      return true;
    }

    if (!rawDataCollection || (rawDataCollection.references.length === 0)) {
      return false;
    }

    if (pagename === 'Isolate data' && !rawDataCollection.hasRawSequences) {
      return false;
    }

    if (pagename === 'Rx history data' && !rawDataCollection.hasRxHistory) {
      return false;
    }

    return true;

  }

  handleClick(pathname, pagename) {
    const {onNavClick} = this.props;

    return async (e) => {
      e && e.preventDefault();

      if (!this.isActiveTag(pathname, pagename)) {
        return;
      }

      if (onNavClick) {
        onNavClick(pathname);
        return;
      }

      const {rawDataCollection} = this.props;
      const state = {
        pathname: window.location.pathname,
        rawDataCollection
      };

      const load = await updateStorage(state);

      this.context.router.push({
        pathname,
        query: {load}
      });
    };
  }

  render() {

    return (
      <ol className={style.navigator}>
        {PAGES.map(([url, name], idx) => {
          let className = null;
          if (!this.isActiveTag(url, name)) {
            className = style.inactive;
          }
          return (
            <li key={idx} className={className}>
              <Link
               to={url}
               onClick={this.handleClick(url, name)}>
                {name}
              </Link>
            </li>
          );
        })}
      </ol>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/navigator/index.js